/** @format */

import { Container } from '@mui/material';
import DonutCard from './DonutCard';
import TableCard from './TableCard';
import { useContext, useEffect, useState } from 'react';
import { HomeContext } from '../Home';
import { getKPI } from '../../../../Services/service.home';
import { useAppContext } from '../../../../store/store.app';
import { buildPayload } from '../../../Library/appfilter.lib';
import { TABS_MAPPING } from '../KPI/KPIContainer';

const revenueIds = [
  { id: 'room_revenue', title: 'Room' },
  { id: 'food_revenue', title: 'Food' },
  { id: 'bev_revenue', title: 'Beverage' },
  { id: 'other_fnb_revenue', title: 'F&B Others' },
  { id: 'spa_revenue', title: 'Spa' },
  { id: 'mod_revenue', title: 'MOD' },
];

function Performance() {
  const [revenueData, setRevenueData] = useState([]);
  const [totalRevenue, setTotalRevenue] = useState(null);
  const [totalRevenueData, setTotalRevenueData] = useState(null);

  const { activeTab } = useContext(HomeContext);

  const {
    appStore: { appFilters },
  } = useAppContext();

  const { PARAMETER, CALC_DATERANGE } = appFilters;

  const payload = {
    ...buildPayload(appFilters),
  };

  useEffect(() => {
    if (!CALC_DATERANGE || !PARAMETER) {
      return;
    }

    let cancelled = false;

    const fetchData = async () => {
      try {
        const [revenueResults, totalResponse] = await Promise.all([
          Promise.all(
            revenueIds.map((item) =>
              getKPI(item.id, TABS_MAPPING[activeTab], payload)
            )
          ),
          getKPI('total_revenue', TABS_MAPPING[activeTab], payload),
        ]);

        if (cancelled) {
          return;
        }

        const dataArr = revenueResults
          .map((item) => {
            const responseData = item?.data;

            if (!responseData) {
              return null;
            }

            const id = responseData.title;

            const revenueItem = revenueIds.find((revenue) => revenue.id === id);

            if (!revenueItem) {
              return null;
            }

            return {
              ...responseData,
              id,
              title: revenueItem.title,
            };
          })
          .filter(Boolean);

        const totalData = totalResponse?.data;

        setRevenueData(dataArr);
        setTotalRevenue(totalData?.value ?? null);
        setTotalRevenueData(totalData ?? null);
      } catch (error) {
        if (!cancelled) {
          console.error('Error fetching revenue data:', error);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [activeTab, CALC_DATERANGE, PARAMETER]);

  return (
    <Container
      maxWidth="lg"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        gap: { xs: 1, sm: 2 },
        mt: { xs: 1, sm: 2 },
        px: { xs: 0, sm: 3 },
        '& > *': {
          minWidth: 0,
          width: '100%',
          flex: { xs: '0 0 auto', sm: '1 1 0' },
        },
      }}
    >
      <DonutCard
        data={revenueData}
        totalRevenue={totalRevenue}
        totalRevenueData={totalRevenueData}
      />

      <TableCard data={revenueData} totalRevenueData={totalRevenueData} />
    </Container>
  );
}

export default Performance;
